import { MAIN_CATEGORIES_ID } from './constants';

import { Navigation } from '@/types/api/product';

export const getCategories = (filters: Navigation['filters'] = []) => {
  // TODO: Needs to be refactored by BE, uncomment this when the BE is fixed.
  // const siblingCategories = filters.find(filter => filter.internalName === SIBLING_CATEGORIES_ID);
  const mainCategories = filters.find(filter => filter.internalName === MAIN_CATEGORIES_ID);

  return mainCategories;
};
